import { AsyncState, unloadedAsyncState } from 'widgets-for-react'
import { ComponentTeaserData } from '../../components/componentTeasers/componentTeasersState'

export type CollectionsLoaderState = AsyncState<CollectionsData>

export type CollectionsData = CollectionData[]

export type CollectionData = {
  Id: string
  Name: string
  Description: string
  Components: ComponentTeaserData[]
}

export const initialCollectionsLoaderState: CollectionsLoaderState =
  unloadedAsyncState()
